var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contacts",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.75,
    height: 44.75,
    viewBox: "0 0 44.75 44.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_74628",
    "data-name": "Path 74628",
    d: "M0,0H44.75V44.75H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_74629",
    "data-name": "Path 74629",
    d: "M33.7,0H7.594a1.865,1.865,0,1,0,0,3.729H33.7A1.865,1.865,0,0,0,33.7,0ZM7.594,44.75H33.7a1.865,1.865,0,0,0,0-3.729H7.594a1.865,1.865,0,1,0,0,3.729ZM35.563,7.458H5.729A3.74,3.74,0,0,0,2,11.188V33.563a3.74,3.74,0,0,0,3.729,3.729H35.563a3.74,3.74,0,0,0,3.729-3.729V11.188A3.74,3.74,0,0,0,35.563,7.458ZM20.646,12.586a4.2,4.2,0,1,1-4.2,4.2A4.2,4.2,0,0,1,20.646,12.586ZM29.969,31.7H11.323V28.9c0-3.114,6.209-4.661,9.323-4.661s9.323,1.548,9.323,4.661Z",
    transform: "translate(1.729 0)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.14734ec0db0a6253b344159d7f4d8bdb.svg";
export { ForwardRef as ReactComponent };